import qs from 'qs';
import { axiosClient } from './axiosClient';
import { commonHeaders } from './common';

export const payCodeDeductServices = {
  getPayCodeDeducts: async () => {
    const response = await axiosClient().get(`Payroll/PayCodes/GetDeducts`, {
      headers: { ...commonHeaders },
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    });
    return response.data.data.records;
  },
  getDeductTemplate: async (PayCode: string) => {
    const response = await axiosClient().get(`Payroll/PayCodes/GetDeduct`, {
      params: {
        PayCode,
      },
      headers: { ...commonHeaders },
    });
    return response.data.data.combos;
  },
  createPayCodeDeducts: (payCode: string, payload: any) => {
    return axiosClient().patch(
      'Payroll/PayCodes',
      { ...payload, PayAD: 'D' },
      {
        params: {
          PayCode: payCode,
          IDNo: 0,
        },
        headers: { ...commonHeaders },
      }
    );
  },
  updatePayCodeDeducts: (IDNo: number, payCode: string, payload: any) => {
    return axiosClient().patch(
      'Payroll/PayCodes',
      { ...payload, PayAD: 'D' },
      {
        params: {
          PayCode: payCode,
          IDNo,
        },
        headers: { ...commonHeaders },
      }
    );
  },
  deletePayCodeDeducts: (IDNo: number) =>
    axiosClient().delete('Payroll/PayCodes', {
      params: {
        IDNo,
      },
      headers: { ...commonHeaders },
    }),
};
